import React from "react";

// One stat tile in the dashboard's top stat-cards row (icon + big number + label).
export default function TspStatCard({ icon: Icon, value, label, tone = "primary" }) {
  return (
    <div className="tsp-stat-card">
      <div className={`tsp-stat-icon tsp-tone-${tone}`}>{Icon && <Icon size={20} />}</div>
      <div className="tsp-stat-body">
        <div className="tsp-stat-value">{value}</div>
        <div className="tsp-stat-label">{label}</div>
      </div>
    </div>
  );
}
